import api from "./api";

export async function fetchQuestionBankQuestions(params = {}) {
  const response = await api.get("/question-bank/questions-details", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionBankQuestionNumberList(params = {}) {
  const response = await api.get("/questions-number-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function saveQuestionBankQuestionAnswer(payload = {}) {
  const response = await api.post("/question-answer-save", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function storeQuestionBankQuestionTime(payload = {}) {
  const response = await api.post("/question-bank/store-time", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function saveQuestionBankGuessAnswer(payload = {}) {
  const response = await api.post("/question-bank/guess-answer", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionBankInstructions(params = {}) {
  const response = await api.get("/instructions", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionBankQuestionReference(params = {}) {
  const response = await api.get("/question-bank/get-question-reference", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function toggleQuestionBookmark(payload = {}) {
  const response = await api.post("/bookmark", payload);
  assertQuestionActionSuccess(response);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function toggleQuestionLike(payload = {}) {
  const response = await api.post("/like", payload);
  assertQuestionActionSuccess(response);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

function assertQuestionActionSuccess(response) {
  const data = response?.data;
  if (data?.error || (data?.code != null && Number(data.code) !== 200)) {
    throw new Error(data?.message || 'Unable to save question changes.');
  }
}

export async function createQuestionReport(payload = {}) {
  const response = await api.post("/report", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionReports(params = {}) {
  const response = await api.get("/reports", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function deleteQuestionReport(payload = {}) {
  const response = await api.delete("/report-delete", {
    data: payload,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function createQuestionNote(payload = {}) {
  const response = await api.post("/notes", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionNotes(params = {}) {
  const response = await api.get("/user-notes", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function deleteQuestionNote(payload = {}) {
  const response = await api.delete("/note-delete", {
    data: payload,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionViewActivity(payload = {}) {
  const response = await api.get("/view", {
    params: payload,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuestionBankGuessScore(params = {}) {
  const response = await api.get("/question-bank/get-guesss-score", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function completeQuestionBankRewardedAd(payload = {}) {
  const response = await api.post("/question-bank/ad-reward", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
